import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ product }: RootState) => product;

export const selectProduct = createSelector(
    selectRoot,
    ({ product }) => product,
);
